import React, { useState } from "react";
import ModalWrapper from "./ModalWrapper";
import { UilSearch } from "@iconscout/react-unicons";
import useSWR from "swr";
import Spinner from "./Spinner";
import { useFormContext, Controller } from "react-hook-form";

export default function CountryModal({ name, onClose, error, label = "Country" }) {
  const [query, setQuery] = useState("");
  const { data, isValidating } = useSWR('/collections/countries');
  const countries = data?.data;
  const filtered = query
    ? countries?.filter((c) =>
      c.name.toLowerCase().includes(query.toLowerCase())
    )
    : countries;

  const { control, handleSubmit, watch, setValue } = useFormContext();
  const country = watch(name);

  const onSubmit = () => {
    onClose();
  };

  const [open, setOpen] = useState(false);

  return (
    <>
      <div>
      {label && <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>}
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className="flex items-center justify-between w-full p-3 bg-white border rounded-md text-left text-sm mb-2"
        >
          <span>
            {country
              ? countries?.find((c) => c.id === country)?.name || "Select country"
              : "Select country"}
          </span>
          <span className="ml-2">
            {open ? (
              <svg className="h-4 w-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" /></svg>
            ) : (
              <svg className="h-4 w-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /></svg>
            )}
          </span>
        </button>
        {error && <p className="text-red-500 text-sm">{error}</p>}
      </div>
      {open && (
        <ModalWrapper title={'Select country'} onClose={() => setOpen(false)}>
          {isValidating ? (
            <Spinner />
          ) : (
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="flex items-center border rounded-md px-2 py-1 mb-4 bg-blue-50">
                <UilSearch className="text-gray-500 w-4 h-4 mr-2" />
                <input
                  type="text"
                  placeholder="Search country..."
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  className="flex-1 bg-transparent outline-none text-sm"
                />
              </div>

              <Controller
                name={name}
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <ul className="space-y-1 overflow-y-scroll h-[300px]">
                    {filtered?.map((c) => (
                      <li key={c.iso2}>
                        <button
                          type="button"
                          onClick={() => {
                            setValue(name, c.id);
                            setOpen(false);
                            handleSubmit(onSubmit)();
                          }}
                          className={`w-full flex items-center px-3 py-2 border-b rounded hover:bg-blue-50 ${country === c.id ? "bg-blue-50" : ""
                            }`}
                        >
                          <img
                            src={`https://flagcdn.com/w40/${c.iso2?.toLowerCase()}.png`}
                            alt={c.name}
                            className="w-6 h-4 object-cover mr-3 rounded-sm shadow"
                          />
                          <span>{c.name}</span>
                        </button>
                      </li>
                    ))}
                  </ul>
                )}
              />
            </form>
          )}
        </ModalWrapper>
      )}
    </>
  );
}
